<button
  class="button button-vi"
  title="Версия для слабовидящих"
  (click)="toggleVisualImpaired()"
></button>
